import {
  isMallIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform.js'
import Url from '@mc/mc-utils/js/url/url'
import { isMeicaiHarmony } from './get_app_info'
import { VERSION } from '../../env'

export const getAppVersion = (appInfo, miniProgramEnv) => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  if (
    isMallIOS() ||
    isMallAndroid() ||
    isMCMallCirculationIOS() ||
    isMCMallCirculationAndroid() ||
    isMCMallKeyCustomerIOS() ||
    isMCMallKeyCustomerAndroid() ||
    isMeicaiHarmony()
  ) {
    return appInfo.appVersion
  }
  if (miniProgramEnv.isMiniProgram) {
    return query.app_version || hashQuery.app_version || ''
  }
  return query.app_version || hashQuery.app_version || VERSION
}
